<button class="border bg-white rounded-xl cursor-pointer border-neutral-200 w-full" mat-ripple (click)="clickBox()">
  @if (headerText) {
    <div class="w-full bg-neutral-100 rounded-t-xl flex gap-x-3.5 items-center py-3 px-3">
      <mat-icon fontSet="material-icons-outlined">
        <ng-content select="[iconHeader]"></ng-content>
      </mat-icon>

      <p class="text-xs text-start">
        {{ headerText }}
      </p>
    </div>
  }
  <div class="px-2 py-3 grid grid-cols-[max-content_auto_max-content] items-center gap-x-3.5 justify-items-start">
    <mat-icon class="text-neutral-400" fontSet="material-icons-outlined">
      <ng-content select="[icon]"></ng-content>
    </mat-icon>

    <div class="text-start">
      @if (title) {
        <p class="text-sm text-neutral-300">
          {{ title }}
        </p>
      }
      @if (label) {
        <p class="text-base text-neutral-600 font-semibold">
          {{ label }}
        </p>
      }

      @if (description) {
        <p class="text-sm">
          {{ description }}
        </p>
      }
    </div>

    <mat-icon> keyboard_arrow_right </mat-icon>
  </div>
</button>
